/**
 * @copyright 2026 @ DigiNet
 * @author ANHTAI
 * @create 2026/07/13 09:15
 * @update 2026/07/13 09:15
 */

import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import Config from "../../../config";
import { Button, Collapse, TextInput } from 'diginet-core-ui/components';
import { makeStyles } from "diginet-core-ui/theme";

const useStyles = makeStyles((theme) => ({
    collapse: {
        margin: '0px -16px',
        width: 'calc(100% + 32px)',
        background: theme?.colors?.fill?.background
    }
}));

const GridToolbarCore = (props) => {
    const classes = useStyles();
    const { buttonCRM, onAddNew, allowAdding, isPer, showSendMail, onSearch, disabledAddNew, onSendMail, filterRender, onOpenLoaded, openFilter, setOpenFilter, showSearchInput } = props;
    const filter = useRef({
        StrSearch: ''
    });
    const isOpened = useRef(false);

    const onButtonClick = (allowAdding) => {
        if (typeof allowAdding == 'undefined' && onAddNew) onAddNew();
        else if (onAddNew && allowAdding >= 4) onAddNew();
    };

    const onSendMailClick = () => onSendMail && onSendMail();

    const onChangeSearch = (e) => {
        const value = e?.value ?? e?.target?.value ?? '';
        filter.current.StrSearch = value;
        onSearch(filter.current.StrSearch);
    };

    const handleOpenFilter = () => {
        if (!isOpened.current && onOpenLoaded) onOpenLoaded();
        isOpened.current = true;
        setOpenFilter(!openFilter);
    };

    const btnAction = (data, index) => {
        const { buttonName = '', color = '', className = '', onClick, disabled, icon = '' } = data || {};
        return <Button key={`buttonGrid${index}`}
            disabled={disabled}
            color={color}
            className={`${className} mgl2x`}
            label={Config.lang(buttonName)}
            startIcon={icon}
            onClick={onClick && onClick} />
    };

    const renderButtonMore = () => {
        const btnMore = buttonCRM.map((data, index) => {
            return btnAction(data, index)
        })
        btnMore.push(btnAction({
            buttonName: 'Loc',
            icon: 'Filter',
            color: 'Warning',
            onClick: () => handleOpenFilter()
        }, buttonCRM.length));
        return btnMore
    };

    return (
        <div>
            <Collapse id={'collapseFilter'} open={openFilter} className={`${classes.collapse} ${openFilter ? '' : 'hide'} pd4x`}>{filterRender}</Collapse>
            <div id={'gridToolbarCore'} className="pdv4x wrap align-between align-center full_w">
                <div className={'wrap align-center valign-middle'}>
                    {onAddNew &&
                        <Button viewType={'filled'}
                            startIcon={'AddFilled'}
                            color={"primary"}
                            onClick={() => onButtonClick(allowAdding)}
                            label={Config.lang("Them_moi1")}
                            disabled={isPer < 2 || allowAdding <= 1 || disabledAddNew} />
                    }
                    {showSendMail &&
                        <Button
                            text={Config.lang("Gui_mail")}
                            color={"primary"}
                            startIcon={"Mail"}
                            viewType={"outlined"}
                            className={onAddNew ? 'mgl2x' : ''}
                            onClick={() => onSendMailClick()}
                        />
                    }
                    {showSearchInput &&
                        <TextInput
                            startIcon={'Search'}
                            className={'mgl2x'}
                            style={{ minWidth: 400 }}
                            placeholder={Config.lang('Nhap_noi_dung_can_tim')}
                            viewType={'outlined'}
                            onChange={onChangeSearch}
                            value={filter.current.StrSearch}
                        />
                    }
                </div>
                <div className={'wrap align-center valign-middle'}>{buttonCRM && renderButtonMore()}</div>
            </div>
        </div>
    )
}
GridToolbarCore.defaultProps = {
    showSearchInput: true,
}

GridToolbarCore.propTypes = {
    showSendMail: PropTypes.bool,
    disabledAddNew: PropTypes.bool,
    openFilter: PropTypes.bool,
    isPer: PropTypes.number,
    allowAdding: PropTypes.number,
    buttonCRM: PropTypes.array,
    onSearch: PropTypes.func,
    onSendMail: PropTypes.func,
    onAddNew: PropTypes.func,
    onOpenLoaded: PropTypes.func,
    setOpenFilter: PropTypes.func,
    filterRender: PropTypes.any,
    showSearchInput: PropTypes.bool,
};

export default GridToolbarCore;